import { Rocket } from "lucide-react";

export const Logo = ({ size = "md" }) => {
  const dims = size === "lg"
    ? { wrap: "h-12 w-12", icon: 26, title: "text-2xl" }
    : { wrap: "h-10 w-10", icon: 22, title: "text-xl" };
  return (
    <div className="flex items-center gap-3" data-testid="rd-logo">
      <div
        className={`${dims.wrap} flex items-center justify-center rounded-lg bg-[#F9DB81] border-2 border-black`}
        style={{ boxShadow: "3px 3px 0 0 rgba(255,255,255,0.85)" }}
      >
        <Rocket size={dims.icon} color="#0A0A0A" strokeWidth={2.6} />
      </div>
      <div className="leading-tight">
        <div className={`font-display font-extrabold tracking-tight ${dims.title}`}>
          ROCKETS<span className="text-[#F9DB81]">DISPATCH</span>
        </div>
        <div className="text-[10px] uppercase tracking-[0.22em] text-zinc-500 font-semibold">
          Freight Brokerage OS
        </div>
      </div>
    </div>
  );
};
